module.exports = __webpack_public_path__ + "static/media/submit-popup.ce91eb05.svg";